// v2/hooks/useAdminCampaigns.js — yonetim kampanyalari
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet, apiPost, qs } from '../utils/api';

export default function useAdminCampaigns(params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tetik, setTetik] = useState(0);
  const abortRef = useRef(null);
  const sorgu = qs(params);

  const yenile = useCallback(() => setTetik((n) => n + 1), []);

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    apiGet(`/v2/admin/campaigns/${sorgu}`, { signal: ctrl.signal })
      .then((veri) => {
        if (ctrl.signal.aborted) return;
        if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Liste alınamadı');
        setData({
          ...veri,
          items: Array.isArray(veri.items) ? veri.items : [],
          summary: veri.summary || {},
          groups: Array.isArray(veri.groups) ? veri.groups : [],
        });
      })
      .catch((e) => {
        if (ctrl.signal.aborted || (e && e.name === 'AbortError')) return;
        setError((e && e.message) || 'Liste alınamadı');
      })
      .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
    return () => ctrl.abort();
  }, [sorgu, tetik]);

  return { data, loading, error, yenile };
}

export const adminCampaignApi = {
  /** Toplu yukleme. onayli=false -> sunucu dogrulamasi (onizleme), true -> yazar. */
  toplu: (satirlar, onayli) =>
    apiPost('/v2/admin/campaigns/bulk/', { rows: satirlar, confirm: Boolean(onayli) }),
  kaydet: (govde) => apiPost('/v2/admin/campaigns/save/', govde),
  durum: (id, status) => apiPost('/v2/admin/campaigns/status/', { id, status }),
  sil: (id) => apiPost('/v2/admin/campaigns/delete/', { id, confirm: true }),
  ara: (kind, q) => apiGet(`/v2/admin/campaigns/search/${qs({ kind, q })}`),
};
